import React from "react";
import { IIconSvgProps } from "../../growbot/icons";

export function ReadingAssessmentSvg({ color = "currentColor", size = 77 }: IIconSvgProps) {
  const width = (size / 56) * 77;
  return (
    <svg
      width={width}
      height={size}
      viewBox="0 0 77 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="icon-reading"
      aria-label="Reading"
    >
      <mask id="mask0_2330_2274" maskUnits="userSpaceOnUse" x="0" y="0" width={width} height={size}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.500244 0.0917969H76.4357V55.7358H0.500244V0.0917969Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_2330_2274)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M74.715 17.4405V51.5355H43.1253L40.4057 53.3912C39.8083 53.799 39.1174 54.0031 38.4257 54.0031C37.7575 54.0031 37.0889 53.8125 36.5042 53.4302L33.6047 51.5355H2.221V17.4405V5.78113L3.7562 4.20726V46.2533C3.7562 46.7318 4.14136 47.1197 4.61658 47.1197H29.0427C29.4195 47.1197 29.8127 47.109 30.218 47.098C32.9841 47.0232 35.8408 46.9453 37.7471 49.8929C37.9117 50.1482 38.1876 50.2868 38.4687 50.2868C38.6296 50.2868 38.7925 50.2414 38.9373 50.1461C39.3357 49.8854 39.4481 49.3488 39.1888 48.9477C36.7571 45.1869 32.9511 45.2894 30.1715 45.3662C29.7823 45.3766 29.4043 45.387 29.0427 45.387H5.47695V3.00794H27.8895C33.2479 3.00794 37.6075 7.39803 37.6075 12.7937V37.6187V39.7785C37.6075 40.257 37.9926 40.6449 38.4678 40.6449C38.9433 40.6449 39.3282 40.257 39.3282 39.7785V37.6187V12.7937V11.6102C39.3282 6.2143 43.1856 1.8245 47.9263 1.8245H67.8738V46.2533C67.8738 46.7318 68.2587 47.1197 68.7342 47.1197C69.2094 47.1197 69.5946 46.7318 69.5946 46.2533V3.00794H71.3411V46.2533C71.3411 46.7318 71.7263 47.1197 72.2015 47.1197C72.677 47.1197 73.0619 46.7318 73.0619 46.2533V4.08683L74.715 5.78113V17.4405ZM75.9424 4.56679L73.5466 2.11097C73.3728 1.93308 73.1671 1.79995 72.9449 1.71274C72.7966 1.45255 72.521 1.27523 72.2015 1.27523H69.5946V0.958149C69.5946 0.479922 69.2094 0.0917969 68.7342 0.0917969H47.9263C43.4351 0.0917969 39.607 3.3126 38.1925 7.79251C36.3404 3.93926 32.4182 1.27523 27.8895 1.27523H4.61658C4.2687 1.27523 3.97101 1.48402 3.83535 1.78292C3.67274 1.86637 3.5216 1.97525 3.3891 2.11097L0.992954 4.56679C0.677195 4.89081 0.500244 5.32687 0.500244 5.78113V17.4405V51.5355C0.500244 52.4922 1.27028 53.2682 2.221 53.2682H33.0954L35.5675 54.8836C36.4204 55.441 37.409 55.7358 38.4257 55.7358C39.4799 55.7358 40.4983 55.4211 41.371 54.8256L43.6533 53.2682H74.715C75.6651 53.2682 76.4357 52.4922 76.4357 51.5355V17.4405V5.78113C76.4357 5.32687 76.2588 4.89081 75.9424 4.56679Z"
          fill={color}
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64.4363 13.0449H47.3349C45.8344 13.0449 44.4133 13.5577 43.2265 14.5281C42.8597 14.8277 42.8142 15.3582 43.1245 15.7121C43.2967 15.9087 43.5417 16.0096 43.789 16.0096C43.9877 16.0096 44.1871 15.9443 44.3507 15.8107C45.2191 15.1005 46.2511 14.7252 47.3349 14.7252H64.4363C64.9168 14.7252 65.3062 14.3491 65.3062 13.8851C65.3062 13.421 64.9168 13.0449 64.4363 13.0449Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64.4363 17.7871H47.3349C45.8341 17.7871 44.4133 18.3001 43.2265 19.2704C42.8597 19.5703 42.8142 20.1004 43.1245 20.4544C43.2967 20.6509 43.5417 20.7518 43.789 20.7518C43.9877 20.7518 44.1871 20.6865 44.3507 20.5529C45.2191 19.8428 46.2511 19.4673 47.3349 19.4673H64.4363C64.9168 19.4673 65.3062 19.0912 65.3062 18.6272C65.3062 18.1632 64.9168 17.7871 64.4363 17.7871Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64.4363 26.6816H47.3349C45.8341 26.6816 44.4133 27.1946 43.2265 28.1649C42.8597 28.4649 42.8142 28.9949 43.1245 29.3489C43.2967 29.5455 43.5417 29.6463 43.789 29.6463C43.9877 29.6463 44.1871 29.581 44.3507 29.4475C45.2191 28.7373 46.2511 28.3618 47.3349 28.3618H64.4363C64.9168 28.3618 65.3062 27.9857 65.3062 27.5217C65.3062 27.0577 64.9168 26.6816 64.4363 26.6816Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M59.1313 32.0176H47.9379C46.4325 32.0176 45.0071 32.5304 43.8166 33.5007C43.4487 33.8004 43.403 34.3308 43.7143 34.6848C43.887 34.8814 44.1331 34.9822 44.3809 34.9822C44.5801 34.9822 44.7802 34.917 44.9442 34.7834C45.8153 34.0732 46.8504 33.6979 47.9379 33.6979H59.1313C59.6133 33.6979 60.0039 33.3218 60.0039 32.8577C60.0039 32.3937 59.6133 32.0176 59.1313 32.0176Z"
        fill={color}
      />
      <mask id="mask1_2330_2274" maskUnits="userSpaceOnUse" x="0" y="0" width={width} height={size}>
        <path fillRule="evenodd" clipRule="evenodd" d="M0.5 55.7353H76.5V0H0.5V55.7353Z" fill="white" />
      </mask>
      <g mask="url(#mask1_2330_2274)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.88966 18.9784H29.9941V8.88943H9.88966V18.9784ZM29.9941 7.11523H9.88966C8.93344 7.11523 8.15894 7.90948 8.15894 8.88943V18.9784C8.15894 19.9583 8.93344 20.7526 9.88966 20.7526H29.9941C30.9503 20.7526 31.7248 19.9583 31.7248 18.9784V8.88943C31.7248 7.90948 30.9503 7.11523 29.9941 7.11523Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.689 23.125H10.1947C9.7211 23.125 9.33722 23.5232 9.33722 24.0144C9.33722 24.5056 9.7211 24.9038 10.1947 24.9038H29.689C30.1626 24.9038 30.5465 24.5056 30.5465 24.0144C30.5465 23.5232 30.1626 23.125 29.689 23.125Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.8553 28.4609H10.1912C9.71952 28.4609 9.33722 28.8591 9.33722 29.3503C9.33722 29.8416 9.71952 30.2397 10.1912 30.2397H20.8553C21.327 30.2397 21.7093 29.8416 21.7093 29.3503C21.7093 28.8591 21.327 28.4609 20.8553 28.4609Z"
          fill={color}
        />
      </g>
    </svg>
  );
}
